import { render, staticRenderFns } from "./FormStartupRegistration.vue?vue&type=template&id=16cb01b6"
import script from "./FormStartupRegistration.vue?vue&type=script&lang=js"
export * from "./FormStartupRegistration.vue?vue&type=script&lang=js"
import style0 from "./FormStartupRegistration.vue?vue&type=style&index=0&id=16cb01b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports